(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-reviews-slider')) {
    class TlReviewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        const step = (dir) => {
          const card = this.track.querySelector('li');
          const w = card ? card.offsetWidth + 16 : 300;
          const max = this.track.scrollWidth - this.track.clientWidth - 2;
          if (dir > 0 && this.track.scrollLeft >= max) this.track.scrollTo({ left: 0, behavior: 'smooth' });
          else this.track.scrollBy({ left: dir * w, behavior: 'smooth' });
        };
        this.querySelector('[data-prev]')?.addEventListener('click', () => { step(-1); this.pause(); });
        this.querySelector('[data-next]')?.addEventListener('click', () => { step(1); this.pause(); });
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduced) {
          this.step = step;
          this.timer = setInterval(() => { if (!this.paused) step(1); }, 5000);
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
          this.track.addEventListener('pointerdown', () => this.pause());
        }
      }
      pause() { this.paused = true; clearTimeout(this.resume); this.resume = setTimeout(() => (this.paused = false), 8000); }
      disconnectedCallback() { clearInterval(this.timer); clearTimeout(this.resume); }
    }
    customElements.define('tl-reviews-slider', TlReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-video-reel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tl-video-reel')) {
    class TlVideoReel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.mode = this.dataset.style;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.index = 0;
        this.visible = false;
        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.small = window.matchMedia('(max-width: 749px)').matches;
        this.touch = window.matchMedia('(hover: none)').matches;

        for (const card of this.cards) {
          const v = this.videoOf(card);
          if (!v) continue;
          const media = v.parentElement;
          v.addEventListener('playing', () => media.classList.add('is-playing'), { signal });
          for (const ev of ['waiting', 'stalled', 'emptied', 'pause', 'error']) {
            v.addEventListener(ev, () => media.classList.remove('is-playing'), { signal });
          }
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.stopTick(); this.pauseAll(); }
          else if (this.visible && this.mode !== 'carousel') this.startTick();
        }, { signal });

        this.io = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            this.visible = entry.isIntersecting;
            this.classList.toggle('is-offscreen', !entry.isIntersecting);
            if (this.mode !== 'carousel') {
              if (entry.isIntersecting) this.startTick(); else { this.stopTick(); this.pauseAll(); }
              continue;
            }
            if (entry.isIntersecting) { this.loadAll(); this.update(); this.start(); }
            else { this.stop(); this.pauseAll(); }
          }
        }, { threshold: 0.2 });
        this.io.observe(this);

        if (this.mode === 'carousel') this.setupCarousel(signal);
        else this.setupMarquee();
      }

      disconnectedCallback() {
        this.stop();
        if (this.io) this.io.disconnect();
        this.stopTick();
        if (this.controller) this.controller.abort();
        clearTimeout(this.restartTimer);
      }

      videoOf(card) { return card.querySelector('video'); }

      // Laufband: Videos starten kurz bevor sie ins Bild laufen und pausieren, wenn sie weit draußen sind
      startTick() {
        if (this.tickTimer) return;
        this.tick();
        this.tickTimer = setInterval(() => this.tick(), 400);
      }
      stopTick() { clearInterval(this.tickTimer); this.tickTimer = null; }
      srcOf(v) { return (this.small && v.dataset.srcSmall) || v.dataset.src; }

      tick() {
        if (document.hidden) return;
        const w = window.innerWidth;
        // Am Handy weniger Videos gleichzeitig: spart Speicher, sonst wird das Band auf iPhones schwarz
        const margin = w * (this.small ? 0.25 : 0.6);
        const unloadAt = w * 1.5;
        for (const card of this.cards) {
          const v = this.videoOf(card);
          if (!v) continue;
          const r = card.getBoundingClientRect();
          const near = r.right > -margin && r.left < w + margin;
          if (near) {
            if (!v.getAttribute('src')) v.src = this.srcOf(v);
            if (v.paused) this.play(v);
          } else {
            if (!v.paused) v.pause();
            const far = r.right < -unloadAt || r.left > w + unloadAt;
            if (far && (this.small || this.touch) && v.getAttribute('src')) {
              v.removeAttribute('src');
              v.load();
            }
          }
        }
      }

      loadAll() {
        for (const card of this.cards) {
          const v = this.videoOf(card);
          if (v && !v.getAttribute('src') && v.dataset.src) v.src = this.srcOf(v);
        }
      }

      pauseAll() { for (const c of this.cards) { const v = this.videoOf(c); if (v) v.pause(); } }

      play(video) { if (!video) return; const p = video.play(); if (p && p.catch) p.catch(() => {}); }

      setupCarousel(signal) {
        const dots = this.querySelector('[data-dots]');
        if (dots) {
          this.cards.forEach((_, i) => {
            const d = document.createElement('button');
            d.type = 'button'; d.className = 'tl-reel__dot';
            d.setAttribute('aria-label', 'Element ' + (i + 1));
            d.addEventListener('click', () => { this.goTo(i); this.restart(); }, { signal });
            dots.appendChild(d);
          });
          this.dots = Array.from(dots.children);
        }
        this.querySelector('[data-prev]')?.addEventListener('click', () => { this.goTo(this.index - 1); this.restart(); }, { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => { this.goTo(this.index + 1); this.restart(); }, { signal });

        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => { this.index = this.closestIndex(); this.update(); }, 80);
        }, { passive: true, signal });
        this.track.addEventListener('pointerdown', () => this.restart(), { signal });
        this.addEventListener('mouseenter', () => this.stop(), { signal });
        this.addEventListener('mouseleave', () => { if (!this.locked) this.start(); }, { signal });
        requestAnimationFrame(() => this.update());
      }

      setupMarquee() {
        const count = this.cards.length / 2 || 1;
        const speed = parseFloat(this.dataset.speed) || 6;
        this.style.setProperty('--tl-marquee-duration', Math.max(16, count * speed) + 's');
      }

      closestIndex() {
        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let best = 0, dist = Infinity;
        this.cards.forEach((c, i) => {
          const d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
          if (d < dist) { dist = d; best = i; }
        });
        return best;
      }

      goTo(i) {
        const n = this.cards.length;
        this.index = ((i % n) + n) % n;
        const c = this.cards[this.index];
        this.track.scrollTo({ left: c.offsetLeft + c.offsetWidth / 2 - this.track.clientWidth / 2, behavior: this.reduced ? 'auto' : 'smooth' });
        this.update();
      }

      update() {
        if (this.mode !== 'carousel') return;
        this.cards.forEach((c, i) => {
          const active = i === this.index;
          c.classList.toggle('is-active', active);
          const v = this.videoOf(c);
          if (!v) return;
          if (active && this.visible) this.play(v);
          else { v.pause(); if (!v.muted) { v.muted = true; c.classList.remove('is-unmuted'); } }
        });
        if (this.dots) this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.index));
      }

      start() {
        if (this.mode !== 'carousel' || this.reduced || this.locked || this.timer || this.cards.length < 2) return;
        this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
      }
      stop() { clearInterval(this.timer); this.timer = null; }
      restart() {
        this.stop();
        clearTimeout(this.restartTimer);
        if (!this.locked) this.restartTimer = setTimeout(() => this.start(), 4000);
      }
    }
    customElements.define('tl-video-reel', TlVideoReel);
  }

  } catch(e) { console.error(e); }
})();
})();
